import { useEffect, useState, useCallback } from 'react';

export function useScrollPosition(key) {
  const [scrollY, setScrollY] = useState(0);
  const [isScrollingDown, setIsScrollingDown] = useState(false);

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const updateScrollPosition = () => {
      const currentScrollY = window.scrollY;
      
      setScrollY(currentScrollY);
      setIsScrollingDown(currentScrollY > lastScrollY && currentScrollY > 50);
      
      lastScrollY = currentScrollY;
    };

    window.addEventListener('scroll', updateScrollPosition, { passive: true });

    return () => {
      window.removeEventListener('scroll', updateScrollPosition);
    };
  }, []);

  const saveScrollPosition = useCallback(() => {
    if (key) {
      const currentPosition = window.scrollY;
      try {
        sessionStorage.setItem(`scrollPosition_${key}`, currentPosition.toString());
        console.log(`Saved scroll position for ${key}:`, currentPosition);
      } catch (error) {
        console.warn('Failed to save scroll position:', error);
      }
    }
  }, [key]);

  const restoreScrollPosition = useCallback(() => {
    if (key) {
      try {
        const savedPosition = sessionStorage.getItem(`scrollPosition_${key}`);
        if (savedPosition) {
          const position = parseInt(savedPosition, 10);
          if (!isNaN(position)) {
            // Use requestAnimationFrame to ensure the DOM is ready
            requestAnimationFrame(() => {
              window.scrollTo({ top: position, behavior: 'smooth' });
              console.log(`Restored scroll position for ${key}:`, position);
            });
          }
        }
      } catch (error) {
        console.warn('Failed to restore scroll position:', error);
      }
    }
  }, [key]);

  const clearSavedPosition = useCallback(() => {
    if (key) {
      try {
        sessionStorage.removeItem(`scrollPosition_${key}`);
        console.log(`Cleared saved scroll position for ${key}`);
      } catch (error) {
        console.warn('Failed to clear scroll position:', error);
      }
    }
  }, [key]);

  return { 
    scrollY, 
    isScrollingDown, 
    saveScrollPosition, 
    restoreScrollPosition,
    clearSavedPosition
  };
}